import { ReactNode } from 'react';
import { cn } from '@anytag/shared-utils';
import { WidgetSelectButton, WidgetSelectButtonProps } from './WidgetSelectButton';

export interface ProfileWidgetTemplateProps {
  className?: string;
  children: ReactNode;
  selectButtonProps?: WidgetSelectButtonProps;
}

export const ProfileWidgetTemplate = ({ className, children, selectButtonProps }: ProfileWidgetTemplateProps) => (
  <div className={cn(styles.wrapper, className)}>
    {selectButtonProps ? <WidgetSelectButton {...selectButtonProps} className={className} /> : null}

    <div className={styles.content}>{children}</div>
  </div>
);

const styles = {
  wrapper: cn('flex h-24 items-center overflow-hidden border-b-border bg-white', {}),
  content: cn('box-border flex h-full flex-1 items-center p-2', {})
};
